/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValueDefaultBoolean
 */
export interface ValueDefaultBoolean {
    /**
     * The value to be used as a default.
     * @type {boolean}
     * @memberof ValueDefaultBoolean
     */
    value: boolean;
    /**
     * Whether the default value should be applied when updating a record.
     * If set to `always`, the default value will be applied when updating a record.
     * If set to `never`, the default value will not be applied when updating a record,
     * only when creating a record.
     * If unspecified, then `always` is assumed.
     * @type {string}
     * @memberof ValueDefaultBoolean
     */
    applyOnUpdate?: ValueDefaultBooleanApplyOnUpdateEnum;
}


/**
 * @export
 */
export const ValueDefaultBooleanApplyOnUpdateEnum = {
    Always: 'always',
    Never: 'never'
} as const;
export type ValueDefaultBooleanApplyOnUpdateEnum = typeof ValueDefaultBooleanApplyOnUpdateEnum[keyof typeof ValueDefaultBooleanApplyOnUpdateEnum];


/**
 * Check if a given object implements the ValueDefaultBoolean interface.
 */
export function instanceOfValueDefaultBoolean(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function ValueDefaultBooleanFromJSON(json: any): ValueDefaultBoolean {
    return ValueDefaultBooleanFromJSONTyped(json, false);
}

export function ValueDefaultBooleanFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValueDefaultBoolean {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
        'applyOnUpdate': !exists(json, 'applyOnUpdate') ? undefined : json['applyOnUpdate'],
    };
}

export function ValueDefaultBooleanToJSON(value?: ValueDefaultBoolean | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'applyOnUpdate': value.applyOnUpdate,
    };
}

